/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const CropRotateIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Crop Rotate',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path d="M23 21h3V10.5a.5.5 0 0 0-.5-.5H16v3h7Z" />
    <path
      d="M28.5 23H13V6.5a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5V10H6.5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5H10v12.5a.5.5 0 0 0 .5.5H23v3.5a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5V26h2.5a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5ZM28.264 3h-.23V.5a.5.5 0 0 0-.5-.5.493.493 0 0 0-.35.147l-4.037 3.537a.5.5 0 0 0 0 .632l4.034 3.537a.493.493 0 0 0 .35.147.5.5 0 0 0 .5-.5V4.958h.23a3.786 3.786 0 0 1 3.781 3.892v.827a.325.325 0 0 0 .326.326h1.3A.326.326 0 0 0 34 9.674v-.827A5.74 5.74 0 0 0 28.264 3ZM8.819 28.147a.493.493 0 0 0-.35-.147.5.5 0 0 0-.5.5v2.541h-.23a3.786 3.786 0 0 1-3.781-3.892v-.827A.325.325 0 0 0 3.629 26h-1.3a.326.326 0 0 0-.329.326v.827A5.74 5.74 0 0 0 7.736 33h.23v2.5a.5.5 0 0 0 .5.5.493.493 0 0 0 .35-.147l4.034-3.537a.5.5 0 0 0 0-.632Z"
    />
  </svg>`;
};
